export default {
  en: {
    hero: {
      1: 'Scroll Down'
    }, token: {
      //mct
      1: 'MCT is the premiere token of Metarising.',
      2: 'Players can use MCT tokens to purchase necessary materials and items,',
      3: ' and to enhance or synthesize those items.',
      4: 'In addition, MCT tokens can be used to mine MRG tokens.',
      5: 'MCT makes the MetaRising-world go ‘round.',

      //mrg
      6: 'The MRG token is the governance token of MetaRising.',
      7: 'This token has a metric that determines the ecosystem of MetaRising ',
      8: 'and can be used to buy NFTs in the NFT marketplace. You can also ',
      9: 'stake MRG tokens with MCT tokens to give you the opportunity to ',
      10: 'acquire new NFTs and in-game items.'
    },

    playToEarn: {

      //농업
      0: 'Farming',
      1: 'One of the major activities in MetaRising is Farming. ',
      2: 'You can plant your crops and harvest them to earn tokens and in-game currency. ',
      3: 'The only things required to begin farming are a “Farming Scythe” and “Seed”.',
      4: 'Once you have planted seeds and harvested the farmland, you can sell the harvested crops to the shop and earn tokens.',
      5: 'The crops currently available are tomatoes, potatoes, and corn.',
      30: 'New crops will be released regularly. In addition, players can work with other players on the farm. By working together, you can multiply the C2E process and earn more!',
      6: 'How to Harvest Crops',
      7: 'You can plant seeds by throwing them into farmland, then pressing two buttons rapidly.',
      8: 'The faster you press the buttons, the more seeds you can plant.',
      9: 'When it is time to harvest, a meter will float above the crop. ',
      10: 'The more precisely the bars and lines match within the meter, the more crops you will be able to harvest.',
      11: 'Tip',
      12: 'The more you learn the relevant skills you need to farm, the more rewards you get.',

      //목장
      13: 'Ranching',
      14: 'Players can raise chickens, sheep, and cows to earn MCT and MRG. It is very important to take care of your animal\'s health as healthy livestock are more valuable, and offer better rewards. You can also work with other players to earn even more rewards!',
      15: 'How to Raise Animals',
      16: 'To keep animals healthy, they must be fed regularly and their by-products must be removed to keep them clean.',
      17: 'Tip',
      18: 'Cattle in the ranch have various unique items which can be obtained through a mini-game played before selling the cattle. Since the obtained items can be exchanged between players and can be re-made as necessary materials through synthesis, collecting many unique items will help you to enjoy MetaRising.',

      //낚시
      19: 'Fishing',
      20: 'Players can go fishing out in the sea in the C2E zone by using a boat. The essential tool for fishing is a “fishing rod”. You may find hidden secrets in the sea while fishing, so be attentive while you explore!',
      21: 'How to Fish',
      22: 'To catch a fish, you need to match the rod and line within the meter that occurs after throwing the line. If you miss it, you will have to throw the line again and wait for the next fish.',
      23: 'Tip',
      24: 'Fishing with an enhanced fishing rod or cooperating with other players can help you catch large and rare fish. Go out into the mysterious deep sea and begin your adventure.',

      //채광
      25: 'Mining',
      26: 'Players can mine in the C2E zone. The essential tool for mining is a “pickaxe”. Mining can yield many important materials, which can be used to upgrade other MetaRising items to their highest tiers.',
      27: 'Caves are a great place to mine, but there are dangers. There are terrifying “living creatures” that live in caves. To be a successful miner, you have to learn to avoid these “living creatures”.',
      28: 'Tip',
      29: 'If you explore the cave with other players, the chances of mining rare minerals and elements will be very high. We recommend going on an adventure to the cave in groups.'
    },

    cleanToEarn: {
      1: 'C2E is the act of playing MetaRising and earning carbon credits ',
      2: 'that can be used to reduce real-world carbon emissions.',


      3: 'Since carbon credits are exchanged with NGOs for real tree planting activities,',
      4: 'players can have an amazing experience of reducing carbon dioxide levels in the real world,',
      5: 'as well as reducing carbon dioxide levels in MetaRising through various activities.',

      6: 'Through various C2E activities you can reduce the carbon dioxide levels. When the carbon dioxide levels decreases by a certain amount,',
      7: 'you earn rewards. The players of MetaRising create a virtuous cycle both in-game, and in the real world as they play.',
      8: 'They create eco-friendly energy and, through their in-game efforts, create real world impact.',


      9: 'Players can choose which C2E zones they want to access.',
      10: 'The Farming Zone is the first area players can earn rewards. Each time a new city is developed and released,',
      11: 'players will be able to explore it and earn new rewards.',


      12: 'Each world has its own unique farming tools that allows players to earn rewards. Through gameplay you can also upgrade items,',
      13: 'which in turn will allow you to gain greater rewards. We will continue to work to make your MetaRising experience continue to be interesting.',

      14: 'Energy is used to participate in C2E activities.',
      15: 'Your Energy is similar to human stamina and is recharged automatically. You can also do things like eating food to recharge energy faster.',
      16: 'Food can be made by crafting items harvested from farming or markets,',
      17: 'so if you want to enjoy MetaRising longer to earn more, eating food will help you on your adventure.'
    },

    ugc: {
      1: 'UGC stands for User Generated Content. In 2023, this tool will allow players to ',
      2: 'create their own personalized objects and sell them on the Marketplace.',
      3: 'Players who own land can transform the land according to their vision and desires. Once you have finished creating your perfect haven, you can host events, create your own market, and engage in many more land-owner-only activities.'
    },

    seedBox: {
      1: 'SeedBox, which is utilized in the ecosystem of MetaRising,',
      2: 'is a DeFi-based staking platform.',
      3: 'Through SeedBox, ',
      4: 'users can stake and mine MRG & MCT tokens,',
      5: 'and also a variety of NFTs.',
      6: 'During the staking period players can stake at any time. Rewards will be paid in proportion to the amount staked and the time staked.',
      7: 'Players can check the rewards accumulated through staking, in real time, during the staking period. Both Ethereum and Binance Smart Chain tokens can be staked, and more blockchains will be added in the future.',
      8: 'Unstaking is also possible at any time. However, please keep in mind that penalties may be charged when unstaking before completion date.',
      9: 'The SeedBox staking reward system is highly competitive as you can receive NFTs by staking MCT & MRG tokens. It is operated as a DeFi system based on smart contracts and Web3, so you can enjoy it quickly and efficiently without KYC or membership registration.',

      10: 'Mining pool',
      11: 'By staking Token 1, you can get a ',
      12: 'new Token 2.',

      13: 'MCT Pool',
      14: 'MCT tokens can be staked in a ',
      15: 'pool with a fixed APR.',

      16: 'NFT Drop',
      17: 'You can acquire NFTs by staking',
      18: 'Token 1 and Token 2.',

      19: 'Main Pool',
      20: 'By staking Token 1 and Token 2,',
      21: 'you can get either Token 1 or Token 2.',

      22: 'Token Drop',
      23: 'By staking Token 1 and Token 2,',
      24: 'you can get a new Token 3.',

      25: 'NFT Pool',
      26: 'By staking Token 1 and NFT, ',
      27: 'you can get a new NFT.'
    },

    chatting: {
      1: 'VOICE & VIDEO CHAT',
      2: 'One of the greatest features of MetaRising is that players can earn more diverse rewards when they collaborate with each other. Collaborative content exists in all C2E activities. Join forces with your friends and guild members to carry out various activities.',
      3: 'If you play MetaRising using voice & video chat, you can collaborate with users from all over the world and can enjoy a more interactive gameplay experience. Feel the vibrancy of play through instant communication.'
    },

    dao: {
      1: 'In MetaRising a “DAO” is a decentralized autonomous organization',
      2: 'that is divided into governance and guild sections.',
      3: 'The Guild Master, who is the head of the guild,',
      4: 'leads the guild and is elected by the guild members.',
      5: 'Governance',
      6: 'Governance DAO allows members to guide the development of MetaRising. Cast your vote and help determine the outcome of the Metaverse.',
      7: 'Guild',
      8: 'Guild DAOs are organized within MetaRising. Joining a guild gives you unique rewards & allows you to participate in exclusive quests.'
    },

    map: {
      1: 'The MetaRising universe is divided into four major worlds.',
      2: 'Each world is made up of distinct and unique cities with different C2E activities conducted within each world.',
      3: 'The Farming World based in Seoul, South Korea is now open.',
      4: 'MetaRising plans to expand the city with continuous updates in future giving you more places to explore.',
      5: '',

      world: {
        1: 'Poseidon World', 2: 'Gaia World', 3: 'Hestia World', 4: 'Hephaestus World'
      },

      detail: {
        1: 'The continent of Poseidon is home to endless emerald seas, and many different species of fish. Risers in this area catch fish and sell them for tokens in the market. Because the waters are ' +
          'so clear, Risers must be careful not to fall in and get lost in the ' +
          'crystal clear waters.',
        2: 'The "Land of Life" was known for being fertile and green, where any crop grew well. During the great destruction the crops were destroyed. This was the first land humans that entered the portal arrived. Using crafted Scythes and Seeds, they began growing crops again. Through their C2E activities, and the tokens earned, they began healing both worlds.',
        3: 'The beautiful continent of Hestia is home to animals that freely roam the endless green meadows. Animals here have a close relationship with humans. Risers that treat them well, feeding them regularly and keeping them clean can get healthy hides and unique items. Risers can exchange or combine these items or evolve them into better items.',
        4: 'The vast mines of Hephaestus dazzle with gem-like minerals. The deepest sections hold rare and valuable treasures, as well as ' +
          'mysterious and dangerous creatures. The Risers who find ores and minerals here can craft items of the highest grades.'
      },

      title: {
        1: 'Poseidon World', 2: 'Gaia World', 3: 'Hestia World', 4: 'Hephaestus World'
      }
    },

    pfp: {
      1: 'BEP-721 is a Binance Smart Chain (BSC) token standard that enables the creation of NFTs (Non-Fungible Tokens).',
      2: 'Each NFT is one-of-a-kind and cannot be exchanged for another token.',
      3: 'Using BEP-721 tokens allows us to tokenize data ownership and attach a unique identity to it.',
      4: 'Every profile picture NFT in MetaRising is created using BEP-721.',
      5: 'Collect rare profile picture NFTs and make your profile picture is as unique as you are.'
    },

    nft: {
      title: {
        1: 'Transportation', 2: 'Pets', 3: 'Land', 4: 'Farming Tools', 5: 'Avatar Skin'
      },
      1: 'Because the world of MetaRising is so vast, it can take a lot of time to explore.<br>' + 'You can quickly travel to hard-to-reach places using transportation.<br>' + '<br>' + 'Fast Travel Transportation can be bought and sold at the NFT Marketplace. If you want to move quickly, we recommend that you explore the Marketplace for different kinds of transportation. The faster you move, the more you can do. The more you can do, the more you can earn!<br>',
      2: 'Pets are currently sold in the NFT Marketplace. Your pets will follow you in game and can be used in mini-games, and other activities. <br><br>Also, by upgrading your pet\'s stats they will help even more with C2E activities. They are a great addition to your team!',
      3: 'The land is based on the MetaRising platform and ecosystem. Landowners can receive MCT rewards through taxes collected from all transactions in MetaRising. It also gives you the opportunity to have preferential access to new content on the metaverse, allowing you to access new content expeditiously.' + '<br><br>' + 'Staking to acquire MRG and crafting materials in-game can only be accessed by landowners. In future, landowners can build buildings on their land and distribute content to other players in MetaRising. If you are a player who wants to enjoy more content on a priority basis, be sure to own a piece of land.\n',
      4: 'As a player you will need tools to participate in C2E activities. This is an essential part of the MetaRising platform. Players must be equipped with a farming "Scythe" in order to participate in the Farming C2E Zone.' + '<br><br>' + 'There are approximately 30,000 scythes that can be acquired, and you can upgrade the scythes through the in-game crafting system. Upgraded scythes can be resold in the market - the higher the stats, the more you can make! MetaRising will be releasing new and exciting tools as well as new C2E activities in future updates.',
      5: 'Avatar skins are a way for players to customize their characters during their MetaRising experience. Players will have the opportunity to purchase rare, and limited edition avatar skins. Avatar Skin NFTs will be available to buy or sell in the in-game marketplace and NFT Marketplace.'
    },
    suggestMusic: 'play with music'
  },
  ko: {
    hero: {
      1: '스크롤을 내려주세요'
    }, token: {
      1: '메타라이징을 플레이할 때 가장 중요한 토큰입니다.',
      2: '이 토큰을 사용해서 필요한 재료 및 아이템을 구매할 수 있습니다.',
      3: '아이템을 강화하고 합성하는데도 사용되기 때문에 가장 중요한 화폐라고 할 수 있습니다.',
      4: '또한 이 토큰으로 MRG 토큰을 채굴할 수 있기 때문에 메타라이징 플레이어라면',
      5: '누구든 MCT 토큰을 최고라고 여길 것이라 자부합니다.',
      6: 'MRG 토큰은 메타라이징의 거버넌스 토큰입니다.',
      7: '메타라이징의 생태계를 결정하는 중요한 척도이기 때문에 MCT 토큰과 더불어',
      8: '아주 중요한 토큰이라고 할 수 있습니다. MRG 토큰은 NFT 마켓 플레이스에서',
      9: 'NFT 아이템을 사는데 사용할 수 있으며 MCT 토큰과 MRG 토큰을 함께',
      10: '스테이킹할 경우 새로운 NFT 를 획득할 수 있는 기회가 주어집니다.'
    },

    playToEarn: {

      // 농업
      0: '농업',
      1: '플레이어는 농장에서 다른 플레이어들과 함께',
      2: '농사를 지을 수 있습니다. 농사를 시작할 때 필수적으로 필요한 것은 바로 “낫”과 “씨앗”인데 이 두 가지를 구입하지 않으면 농사를 지을 수 없습니다.',
      3: '플레이어는 농지에 씨앗을 심고 잘 키운 작물을 수확한 후, ',
      4: '수확한 작물들을 상점에 판매하여 토큰을 획득할 수 있습니다.',
      5: '현재 상점에 판매할 수 있는 작물들은 토마토, 감자, 옥수수입니다. 새로운 작물들은 지속적인 업데이트를 통해 출시될 예정이니 많은 기대와 성원 부탁드립니다.',
      6: '작물 수확 방법',
      7: '작물을 수확하기 위해 농지에 씨앗을 던져 씨앗을 심어야 합니다.',
      8: '이때 빠르게 두 개의 버튼을 눌러야 씨앗이 심어지는데, 버튼을 더 빨리 누를수록 많은 씨앗을 심을 수 있습니다.',
      9: '수확할 시간이 되면 농작물 위에 미터기가 떠오릅니다.',
      10: '미터기 내에 막대와 선이 정확하게 일치할수록 더 많은 작물을 수확할 수 있게 됩니다.',
      11: 'Tip',
      12: '농사를 짓기 위해 필요한 관련 기술을 배우면 더 많은 보상을 얻을 수 있습니다',

      // 목장
      13: '목장',
      14: '플레이어는 목장에서 다른 플레이어들과 함께 닭, 양, 소를 키울 수 있습니다. 건강한 가축 일수록 비싸게 거래되고 좋은 보상을 주기 때문에 그들의 건강을 챙기는 것은 아주 중요합니다.',
      15: '방법',
      16: '가축들을 건강하게 만들기 위해서는 주기적으로 사료를 공급해 주어야 하며 청결한 상태를 유지하도록 부산물을 치워주어야 합니다.',
      17: 'Tip',
      18: '목장의 가축들은 제각기 다른 고유 아이템을 보유하고 있는데, 해당 아이템은 가축을 판매하기 전 미니게임을 통해 얻을 수 있습니다. 얻은 아이템들은 플레이어 간 교환이 가능하고 합성을 통해 필요한 재료로 재탄생 시킬 수 있기 때문에 고유 아이템들을 많이 모아두는 것이 메타라이징을 즐기는 데 도움이 될 것입니다.',

      //낚시
      19: '낚시',
      20: '플레이어는 C2E 공간에서 배를 타고 바다로 나가 낚시를 할 수 있습니다. 낚시를 하기 위해 필수적으로 필요한 도구는 “낚싯대”입니다. 낚시 중 바닷속 숨겨진 비밀을 찾을 수도 있으니 항상 주의를 기울이시기 바랍니다.',
      21: '낚시 방법',
      22: '물고기를 잡기 위해서는 낚싯대를 던진 후 발생하는 미터기 내에 막대와 선을 일치시켜야 합니다. 이를 놓친다면 다시 낚싯대를 던져 다음 물고기를 기다려야 합니다.',
      23: 'Tip',
      24: '강화된 낚싯대로 낚시를 하거나 다른 플레이어와 협동한다면 크고 희귀한 어종을 잡을 수 있습니다. 신비롭고 깊은 바다로 나가 당신만의 모험을 펼쳐보시길 바랍니다.',

      //채광
      25: '채광',
      26: '플레이어는 C2E 공간에서 채광을 할 수 있습니다. 채광을 하기 위해 필수적으로 필요한 도구는 “곡괭이”입니다. 이곳에서 채광을 할 때 아주 중요한 재료가 나올 수 있는데, 이는 메타라이징의 아이템을 최상의 등급으로 만들 수 있습니다.',
      27: '채광을 할 수 있는 동굴은 매우 좋은 곳이지만 동시에 위험이 도사리고 있기도 합니다. 동굴에 살고 있는 무시무시한 “생명체”가 있기 때문입니다. 부디 이 “생명체”를 피해 채광에 성공하시길 바랍니다.',
      28: 'Tip',
      29: '다른 플레이어들과 함께 동굴을 탐험한다면 희귀 광물과 원소를 채굴할 수 있는 확률이 매우 높아질 예정이니 다 같이 동굴로 모험을 떠나는 것을 추천합니다.',
      30: ''

    },

    cleanToEarn: {
      1: 'C2E란 메타라이징을 플레이하며 현실 세계의 탄소 배출량을 줄이는데 사용할 수',
      2: '있는 탄소 크레딧을 획득할 수 있는 행위입니다.',

      3: '탄소 배출권은 NGO와 함께 실제 나무를 심는 활동으로 교환되기 때문에',
      4: '플레이어는 다양한 활동들을 통해 메타라이징의 이산화탄소 수치를 줄일 수 있을 뿐만 아니라',
      5: '현실 세계의 탄소량이도 동시에 줄어드는 놀라운 경험을 할 수 있습니다.',

      6: '이산화탄소 수준이 일정량 감소하면 플레이어는 C2E 활동을 통해 보상을 얻을 수 있습니다.',
      7: '메타라이징의 플레이어는 친환경적인 에너지를 만들어냄과 동시에 현실 세계에 전달하기 때문에',
      8: '사회에 선순환을 일으키는 아주 중요한 존재입니다.',

      9: '플레이어는 가고 싶은 C2E 공간을 고를 수 있습니다.',
      10: 'Farming zone은 플레이어가 보상을 획득할 수 있는 첫 번째 공간입니다.',
      11: '추후 새로운 월드가 개발될 때마다 플레이어는 자신이 가지고 있는 기술을 마스터할 수 있게 됩니다.',

      12: '각 공간에는 플레이어가 더 많은 수익을 올릴 수 있도록 하는 도구가 있으며',
      13: '업그레이드 또한 가능해 더 흥미로운 메타라이징의 세계로 인도하는 중요한 요소가 될 것입니다.',

      14: 'C2E 활동에 참여하기 위해서는 에너지를 사용해야 합니다.',
      15: '에너지는 인간의 체력과도 같은 것으로 자동으로 재 충전이 가능합니다. 더 빨리 충전하기 위해서는 음식을 먹는 방법이 있습니다.',
      16: '음식은 게임이나 마켓에서 수확한 아이템을 제작하여 만들 수 있기에 더 빠르고 편리한 메타라이징을 즐기고 싶다면',
      17: '음식을 먹는 것도 모험에 도움이 됩니다.'
    },

    ugc: {
      1: 'UGC란 User Generated Content의 약자로 사용자 제작 콘텐츠라는 뜻입니다.',
      2: '추후 2023년에 출시될 예정으로 플레이어는 이 도구를 사용하여 자신만의 개성 있는 오브젝트를 만들 수 있으며 마켓플레이스에서 판매도 가능합니다.',
      3: '토지를 보유하고 있는 플레이어는 자신의 가치관과 독특한 감각에 따라 자유롭게 토지를 꾸밀 수 있으며 다양하게 활용할 수 있습니다. 자유롭게 토지를 꾸민 후 자신만의 공간을 만들어 여러 활동을 하시길 바랍니다.'
    },

    seedBox: {
      1: '마이크로투버 및 메타라이징의',
      2: '생태계에서 활용되는 시드박스는 DeFi 기반 스테이킹 플랫폼입니다.',
      3: '시드박스를 통해 MRG 토큰과 MCT 토큰을',
      4: '스테이킹하고 채굴할 수 있고 이 외에도 다양한 NFT를',
      5: '받기 위해서 시드박스를 이용할 수 있습니다.',
      6: '스테이킹 기간 중에는 언제든지 스테이킹이 가능하며 이로 인한 보상은 스테이킹 시간에 비례하여 지급됩니다.',
      7: '스테이킹 진행 시 실시간으로 쌓이는 보상을 확인할 수 있어 내가 얼마나 보상을 받을 수 있는지 즉각적으로 알 수 있습니다. 이더리움과 바이낸스 스마트 체인 모두 스테이킹이 가능하며 추후 사용 가능한 체인들이 추가될 예정입니다.',
      8: '스테이킹 해지도 언제든 가능합니다. 하지만 스테이킹 해지를 진행할 시 패널티가 부가될 수도 있다는 점 명심해 주시길 바랍니다.',
      9: 'MCT 토큰과 MRG 토큰 스테이킹을 통해 NFT를 받을 수있기 때문에 메타라이징 스테이킹 보상 시스템은 100% 합리적입니다. 유용한 계약에 의한 DeFi 시스템으로 운영되고 Web3로 구현돼 별도의 KYC나 회원가입 절차 없이 쉽고 빠르게 즐길 수 있습니다.',

      10: '마이닝 풀',
      11: '토큰 1을 스테이킹하여 새로운 토큰 2를',
      12: '받을 수 있습니다.',

      13: 'MCT 풀',
      14: 'APR이 정해진 풀에서 MCT 토큰을',
      15: ' 스테이킹 할 수 있습니다.',

      16: 'NFT 드랍',
      17: '토큰 1과 토큰 2를 스테이킹하여 NFT를',
      18: ' 획득할 수 있습니다.',

      19: '메인 풀',
      20: '토큰 1과 토큰 2를 스테이킹하여 토큰 1 또는',
      21: '토큰 2를 받을 수 있습니다.',

      22: '토큰 드랍',
      23: '토큰 1과 토큰 2를 스테이킹하여 토큰 3을',
      24: ' 받을 수 있습니다',

      25: 'NFT 풀',
      26: '토큰1과 NFT을 스테이킹 하여',
      27: '새로운 NFT를 받을 수 있습니다.'
    },

    chatting: {
      1: '음성 & 화상 채팅',
      2: '메타라이징의 큰 특징 중 하나는 플레이어들끼리 협업하였을 때 더욱 다양하고 많은 보상을 획득할 수 있다는 것입니다. 모든 C2E 활동에는 협동 콘텐츠가 존재합니다. 같이 플레이하는 친구들, 길드원들과 함께 힘을 합쳐 여러 활동을 수행해 보세요.',
      3: '음성 & 화상 채팅을 사용하여 메타라이징을 플레이한다면 전 세계 유저들과 협동할 수 있으며 더욱더 재미있는 플레이를 즐길 수 있습니다. 즉각적인 소통을 통해 플레이의 생동감을 느껴보세요.'
    },

    dao: {
      1: '메타라이징의 DAO는 탈 중앙화 자율조직으로',
      2: '거버넌스와 길드로 나누어집니다.',
      3: '길드의 수장인 길드 마스터는 길드를 이끌어 나가는 존재이며',
      4: '길드원의 투표로 인해 결정됩니다.',
      5: 'Governance',
      6: '거버넌스 DAO는 회원이 메타라이징의 발전 방향을 결정하고 개발에 대한 중요한 변경 사항에 대해 투표할 수 있도록 합니다.',
      7: 'Guild',
      8: '길드 DAO는 메타라이징 내에 구성되어 있는 길드에 가입함으로써 고유한 보상을 주는 독점 퀘스트에 참여할 수 있도록 합니다.'
    },

    map: {
      1: '메타라이징의 세계는 크게 4개의 공간으로 나누어집니다.',
      2: '각기 특색이 뚜렷하고 독특한 월드로 이루어져 있으며, 해당 월드들 안에는 각기 다른 C2E 활동을 할 수 있습니다.',
      3: '대한민국 서울을 기반으로 한 K 시티 광장에서 포탈을 통해 각각의 월드로 이동이 가능합니다.',
      4: '현재 가이아월드가 오픈된 상태로 각종 농사와 C2E 활동이 가능합니다.',
      5: '추후 지속적인 업데이트를 통해 나머지 월드가 열릴 예정이니 많은 곳을 누비며 모험을 즐기시길 바랍니다.',
      world: {
        1: '포세이돈 월드', 2: '가이아 월드', 3: '헤스티아 월드', 4: '헤파이스토스 월드'
      },
      detail: {
        1: '투명한 에메랄드 빛 바다가 끝없이 펼쳐진 포세이돈에는 많은 종류의 물고기들이 서식하고 있습니다. 물이 맑기 때문에 자칫하면 바다에 빠질 수 있으니 이곳에서는 안전에 주의하세요. 알 수 없는 파동으로 인해 생산 활동을 이어나가야 하는 지금, 라이저들은 낚시를 통해 여러 물고기를 채취하고 이 활동을 통해 얻을 수 있는 토큰은 현실의 위기를 해결할 수 있는 열쇠가 되어줄 것입니다.',
        2: '비옥하고 푸르른 땅이었기에 어떤 작물이든 잘 자라 “생명의 땅”이라고 불렸습니다. 하지만 알 수 없는 파동으로 인해 세계가 갈라지며 사람들은 이곳에서 현실의 위기를 타개하기 위한 생산 활동을 시작하게 되었습니다. 이 곳에서는 낫과 씨앗을 통해 C2E활동을 할 수 있게 되며 이 활동을 통해 얻을 수 있는 토큰은 현실의 위기를 해결할 수 있는 열쇠가 되어줄 것입니다.',
        3: '끝없이 펼쳐진 푸르른 초원을 자유롭게 거니는 동물들이 평화롭습니다. 이곳의 동물들에게 주기적으로 사료를 공급해주고 청결한 상태를 유지시켜 준다면 건강한 가죽을 획득할 수 있을 것입니다. 또한 헤스티아의 동물들은 제각기 다른 고유한 아이템을 가지고 있어서 각 동물들이 주는 아이템들을 교환하거나 합성한다면 더 좋은 아이템으로 진화시킬 수 있습니다.',
        4: '드넓은 광산에 보석같이 빛나는 광물들이 찬란합니다. 이곳의 광물들은 인적이 드문 곳일 수록 가치가 높다고 알려져 있습니다. 만약 어두운 곳으로 진입할 시 위험한 생명체를 발견할 수 있으니 주의하세요. 라이저들은 여러 광물을 채취하며 발견되는 재료로 여러 아이템을 최상의 등급으로 만들 수 있기에 이곳은 매우 중요한 지역이라고 평가 받습니다.'
      },
      title: {
        1: '포세이돈 월드', 2: '가이아 월드', 3: '헤스티아 월드', 4: '헤파이스토스 월드'
      }
    },

    pfp: {
      1: 'BEP 721은 대체 불가능하고 독창적인 토큰입니다.',
      2: '프로필 사진은 바로 이 토큰으로 제작되었기에 메타라이징에서 단 하나뿐입니다.',
      3: '플레이어는 프로필 사진 NFT를 통해 자신의 프로필을 설정할 수 있습니다.',
      4: '컬렉션의 모든 프로필 사진 NFT는 유니크합니다.',
      5: '희귀한 프로필 사진 NFT를 수집하고 자신의 프로필을 독특하고 새롭게 꾸며보세요.'
    },

    nft: {
      title: {
        1: '이동 수단', 2: '반려동물', 3: '토지', 4: '파밍도구', 5: '아바타 스킨'
      },
      1: '플레이어가 게임 내에서 이동할 수 있는 수단을 의미합니다.<br class="hidden lg:block">' + '메타라이징의 세계는 아주 방대하기 때문에 이동하는데 많은 시간이  걸리지만 이동 수단을 통해 ' + '원하는 곳으로 빠르게 이동할 수 있습니다.<br class="hidden lg:block">' + '<br>' + '또한 이동 수단 NFT는 NFT 마켓 플레이스에서 사고팔 수 있으니<br class="hidden lg:block">' + '빠른 이동을 원하시는 플레이어라면 이동 수단을 꼭 소지하시길 권장합니다.<br>',
      2: '반려동물은 메타라이징 내에서 소유자만을 따릅니다.<br>' + '또한 반려동물의 능력치를 업그레이드하면 C2E 활동에 더 큰 도움을 주기 때문에 매우 유용하게 ' + '사용됩니다.<br class="hidden lg:block">' + '<br>' + '현재 반려동물은 NFT 마켓 플레이스에서 판매되고 있으며 미니게임 또한 참여할 수 있어<br class="hidden lg:block"> 활용도가 매우 높습니다.',
      3: '토지는 메타라이징 플랫폼과 생태계를 바탕으로 이루어져 있습니다.<br>' + '토지 소유자는 메타라이징의 모든 거래에서 누적되는 세금을 통해 MCT 보상을 받을 수 있습니다. ' + '또한 메타버스의 새 콘텐츠에 우선적으로 접근할 수 있는 기회가 주어져 새 콘텐츠를 더 빠르고' + '효율적으로 이용할 수 있습니다.<br class="hideen lg:block">' + '<br>' + '게임 내에서 MRG 및 제작 재료를 획득하기 위한 스테이킹은 토지 소유자만이 사용할 수 있습니다.<br class="hidden lg:block">' + '추후 토지 소유자는 자신의 토지에 건물을 짓고 메타라이징에서 다른 플레이어들에게 콘텐츠를 ' + '제공할 수 있게 됩니다. 더 빠르고 많은 콘텐츠를 즐기고 싶으신 플레이어라면 꼭 토지를 소지하시길 ' + '바랍니다.',
      4: 'C2E 활동을 하기 위해서는 도구가 필요합니다.<br>' + '이는 메타라이징의 시스템에서 가장 핵심적인 부분입니다. 가장 먼저 공개될 C2E 공간인 농장에서 ' + '플레이어는 농사를 짓기 위해  농업 도구인 "낫"을 장착해야 합니다.<br>' + '<br>' + '낫은 농장에서 약 3만 개를 획득할 수 있는데 제작 시스템을 통해 낫을 업그레이드할 수 있습니다. ' + '업그레이드된 낫은 시장에서 되팔 수 있으며 능력치가 좋을수록 높은 가격에 팔 수 있습니다.<br class="hidden lg:block"><br class="hidden lg:block">' + '추후에 더 많은 도구들과 새로운 C2E 활동이 추가될 예정입니다.',
      5: '아바타 스킨은 플레이어가 캐릭터를 커스터마이징 하도록 돕습니다.<br>' + '아바타는 메타버스에서 플레이어가 자신만의 독특한 특성을 뽐낼 수 있는 중요한 요소이기 때문에 희귀하고 제한된 수량의 아바타 스킨이 출시될 예정입니다. 이 아바타 스킨 NFT는 게임 플레이 및 NFT 마켓플레이스에서 구매할 수 있습니다'
    },
    suggestMusic: '음악과 함께 즐기기'
  }
}
